import { ExternalLink } from "lucide-react";

const footerLinks = {
  services: [
    { label: "Sovereign Custody", href: "#overview" },
    { label: "Infrastructure Provisioning", href: "#overview" },
    { label: "Asset Intelligence", href: "#overview" },
    { label: "Sovereign Value Score", href: "#risk" },
  ],
  company: [
    { label: "DrkLynX", href: "#divisions" },
    { label: "NoirLynX Intelligence", href: "#divisions" },
    { label: "JetHostHub", href: "#divisions" },
    { label: "Research Division", href: "#trust" },
  ],
  legal: [
    { label: "The Sovereignty Standard", href: "#", external: true },
    { label: "Privacy Policy", href: "#" },
    { label: "Terms of Service", href: "#" },
    { label: "Regulatory Disclosures", href: "#" },
  ],
};

export default function Footer() {
  const scrollTo = (href) => {
    if (href.startsWith("#") && href.length > 1) {
      const el = document.getElementById(href.slice(1));
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer
      data-testid="institutional-footer"
      className="border-t border-slate-800"
    >
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8">
          {/* Brand column */}
          <div className="lg:col-span-4">
            <span className="font-serif text-lg font-bold text-white tracking-tight block mb-4">
              JCAM
            </span>
            <p className="text-xs text-slate-500 leading-relaxed mb-6 max-w-xs">
              J. Carter Asset Management delivers sovereign-grade infrastructure,
              custody, and intelligence for institutional clients worldwide.
            </p>
            <div className="space-y-1.5">
              <p className="text-xs text-slate-500">
                J. Carter Asset Management, LLC
              </p>
              <p className="text-xs text-slate-600">
                Nashville, Tennessee, United States
              </p>
            </div>
          </div>

          {/* Services */}
          <div className="lg:col-span-2 lg:col-start-6">
            <p className="text-[10px] tracking-[0.2em] uppercase text-slate-600 mb-5">
              Services
            </p>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => scrollTo(link.href)}
                    className="text-xs text-slate-400 hover:text-white transition-colors duration-300"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="lg:col-span-2">
            <p className="text-[10px] tracking-[0.2em] uppercase text-slate-600 mb-5">
              Divisions
            </p>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => scrollTo(link.href)}
                    className="text-xs text-slate-400 hover:text-white transition-colors duration-300"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div className="lg:col-span-2">
            <p className="text-[10px] tracking-[0.2em] uppercase text-slate-600 mb-5">
              Legal
            </p>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.label}>
                  <a
                    data-testid={link.label === "The Sovereignty Standard" ? "footer-sovereignty-link" : undefined}
                    href={link.href}
                    className="text-xs text-slate-400 hover:text-white transition-colors duration-300 inline-flex items-center gap-1"
                  >
                    {link.label}
                    {link.external && <ExternalLink className="w-2.5 h-2.5" />}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-slate-800/50">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p
            data-testid="footer-copyright"
            className="text-[10px] text-slate-600 tracking-wide"
          >
            &copy; 2024&ndash;2026 J. Carter Asset Management, LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-[10px] text-slate-700 tracking-wide">Q-Day Hardened</span>
            <span className="text-[10px] text-slate-700 tracking-wide">SOC 2 Type II</span>
            <span className="text-[10px] text-slate-700 tracking-wide">ISO 27001</span>
            <span className="text-[10px] text-slate-700 tracking-wide">NIST PQC</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
